import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const putCodeCountry = (params) => {
    return axios.put(`${backendHost}/api/admin/code_country/${params.id}`);
};
